import React from "react";
import "./Card.css";

interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  width?: "full" | "half" | "quarter" | "eighth";
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  className = "",
  width,
}) => {
  var widthClass = "";
  if (width === "full") widthClass = "card-full-width";
  if (width === "half") widthClass = "card-half-width";
  if (width === "quarter") widthClass = "card-quarter-width";
  if (width === "eighth") widthClass = "card-eighth-width";

  return (
    <div className={`card ${widthClass} ${className}`}>
      {title && <h3 className="card-title">{title}</h3>}
      <div className="card-content">{children}</div>
    </div>
  );
};

export default Card;
